import React from "react";
import { useTranslation } from "react-i18next";
import { Waves, Mail } from "lucide-react";

import LanguageSwitcher from "./LanguageSwitcher";
import { CONTACT_EMAIL, CONTACT_PHONE_DISPLAY } from "../config/contact";

const sections = ["home", "tours", "about", "contact"] as const;

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 py-12 text-white">
      <div className="container mx-auto px-4">
        <div className="mb-8 grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <Waves className="h-8 w-8 text-primary" />
              <span className="text-xl font-bold">MB Floripa</span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">{t("footer.tagline")}</p>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-bold">{t("footer.quickLinks")}</h3>
            <ul className="space-y-2 text-sm">
              {sections.map((section) => (
                <li key={section}>
                  <a href={`/#${section}`} className="text-slate-400 transition-colors hover:text-primary">
                    {t(`nav.${section}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-lg font-bold">{t("footer.contact")}</h3>
            <ul className="space-y-2 break-words text-sm text-slate-400">
              <li>{CONTACT_PHONE_DISPLAY}</li>
              <li>{CONTACT_EMAIL}</li>
              <li>{t("contact.addressLine1")}</li>
            </ul>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="mb-4 text-lg font-bold">{t("footer.social")}</h3>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                aria-label={t("contact.email")}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-slate-800 text-slate-400 transition-colors hover:bg-primary hover:text-white"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <div>
              <h3 className="mb-3 text-lg font-bold">{t("lang.label")}</h3>
              <LanguageSwitcher tone="dark" />
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-xs text-slate-500">
          <p>
            &copy; {new Date().getFullYear()} MB Floripa Turismo. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
